import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

const { Background, FontColor } = sharedComponentColorKeys.BetaBadge

const betaBadgeStyleParts = ['container', 'contentContainer', 'text'] as const

const helpers = createMultiStyleConfigHelpers(betaBadgeStyleParts)

export const BetaBadgeStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentContainer: {
      height: '1.25rem',
      px: '0.25rem',
      alignItems: 'center',
      gap: '0.375rem',
      background: Background,
      userSelect: 'none',
      borderRadius: '0.25rem',
    },
    text: {
      textStyle: textStyleKeys.Body4_Bold,
      color: FontColor,
    },
  },
})

const themeKey = getName({ BetaBadgeStyle })
export const useBetaBadgeStyles = () =>
  useCustomMultiStyleConfig<typeof betaBadgeStyleParts>(themeKey)

export const createNewBadgeStyleContext =
  createCustomStyleContext<typeof betaBadgeStyleParts>(themeKey)
